export default __webpack_public_path__ + "static/media/waves.c62baa49.svg";